import {
    WAIT_INIT_VISUAL,
    GET_VISUAL_GROUP_RSSI_INFO,
    GET_VISUAL_GROUP_INTERIOR_GRAPH,
    DO_DISPLAY_BLUEPRINT,
    GET_VISUAL_MANAGER_DETAIL,
    SAVE_VISUAL_MANAGER_DETAIL,
    DELETE_VISUAL_DATA,
    DELETE_VISUAL_DATA_SUCCESS,
    DELETE_VISUAL_DATA_FAIL,
    GET_AVAILABLE_DEVICE_DATA,
    GET_AVAILABLE_DEVICE_DATA_SUCCESS,
    GET_AVAILABLE_DEVICE_DATA_FAIL,

    GET_VIRTUAL_DEVICE_DATA,
    GET_VIRTUAL_DEVICE_DATA_SUCCESS,
    GET_VIRTUAL_DEVICE_DATA_FAIL,

    // visual list
    GET_VISUAL_LIST,
    GET_VISUAL_LIST_FAIL,
    GET_VISUAL_LIST_SUCCESS,
    GET_VISUAL_LIST_ID_SUCCESS,
    GET_VISUAL_LIST_ID_FAIL,

    // floor plan
    GET_FLOOR_PLAN_DATA,
    SAVE_FLOOR_PLAN_DATA,
    SAVE_FLOOR_PLAN_DATA_SUCCESS,
    SAVE_FLOOR_PLAN_DATA_FAIL,
    DELETE_FLOOR_PLAN,
    DELETE_FLOOR_PLAN_SUCCESS,
    DELETE_FLOOR_PLAN_FAIL,
    FILTER_FLOOR_PLAN,
    DO_GET_FLOOR_PLAN_PROJECT_LIST,
    DO_GET_FLOOR_PLAN_PROJECT_LIST_SUCCESS,
    DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL,
    GET_FLOOR_PLAN_DETAIL_SUCCESS,
    GET_FLOOR_PLAN_DETAIL_FAIL,
    GET_FLOOR_PLAN_DETAIL,
    RESET_FLOOR_PLAN_DATA,
    GET_VISUAL_LIST_ID,

    // heatmap data
    GET_HEATMAP_DATA,
    GET_HEATMAP_DATA_SUCCESS,
    GET_HEATMAP_DATA_FAIL,
    GET_HEATMAP_ALL_DATA,
    GET_HEATMAP_ALL_DATA_SUCCESS,
    GET_HEATMAP_ALL_DATA_FAIL,

    // virtual device
    SAVE_VIRTUAL_DEVICE_INFO,
    SAVE_VIRTUAL_DEVICE_INFO_SUCCESS,
    SAVE_VIRTUAL_DEVICE_INFO_FAIL,
    DELETE_VIRTUAL_DEVICE,
    DELETE_VIRTUAL_DEVICE_SUCCESS,
    DELETE_VIRTUAL_DEVICE_FAIL,

    // visual graph
    SAVE_GRAPH_DATA,
    SAVE_GRAPH_DATA_SUCCESS,
    SAVE_GRAPH_DATA_FAIL,

    DO_SELECT_FLOOR_PLAN_PROJECT,
    SET_FLOOR_PLAN_PROJECT_LIST,

    // scale data
    SAVE_SCALE_DATA_SUCCESS,
    SAVE_SCALE_DATA_FAIL,
    SAVE_SCALE_DATA,
    SAVE_CHANNEL_RECOMMENDATION_SUCCESS,
    SAVE_CHANNEL_RECOMMENDATION_FAIL,
    SAVE_CHANNEL_RECOMMENDATION,
    GET_INTERIOR_GRAPH_SUCCESS,
    GET_INTERIOR_GRAPH_FAIL,
    GET_INTERIOR_GRAPH,
    PRE_CHANGE_FLOOR_PLAN, CONTINUE_TO_CHANGE_FLOOR_PLAN, END_CHANGING_FLOOR_PLAN,
    GET_VISUAL_MANAGER_MODAL_SUCCESS,
    GET_VISUAL_MANAGER_MODAL_FAIL,
    GET_VISUAL_MANAGER_MODAL,

} from "../actions/visual/index";

const doAction = (state, action) => {  
    switch (action.type) {

        case GET_VISUAL_LIST:
          return {
            ...state,
            status: GET_VISUAL_LIST,
            visualList: null
          }

        case GET_VISUAL_LIST_SUCCESS:
          return {
            ...state,
            status: GET_VISUAL_LIST_SUCCESS,
            visualList: action.params.visualList
          }
        case GET_VISUAL_LIST_FAIL:
          return {
            ...state,
            status: GET_VISUAL_LIST_FAIL,
            visualList: null
          }
        case GET_VISUAL_LIST_ID:
            return {
                ...state,
                isLoadingProject: true,
            }
        case GET_VISUAL_LIST_ID_SUCCESS:
            return {
                ...state,
                status: GET_VISUAL_LIST_ID_SUCCESS,
                visualListId: action.params.visualListId,
                isLoadingProject: false
            }
        case GET_VISUAL_LIST_ID_FAIL:
            return {
                ...state,
                status: GET_VISUAL_LIST_ID_FAIL,
                visualListId: null,
                isLoadingProject: false,
            }
        case GET_FLOOR_PLAN_DETAIL:
            return {
                ...state,
                status: GET_FLOOR_PLAN_DETAIL,
                isLoadingFloorData: true,
            }
        case GET_FLOOR_PLAN_DETAIL_SUCCESS:
            return {
                ...state,
                status: GET_FLOOR_PLAN_DETAIL_SUCCESS,
                floorPlanData: action.params.floorPlanData,
                isLoadingFloorData: false,
            }
        case GET_FLOOR_PLAN_DETAIL_FAIL:
            return {
                ...state,
                isLoadingFloorData: false,
                error: action.params.message
            }
        case RESET_FLOOR_PLAN_DATA:
            return {
                ...state,
                visualListId: null,
                isLoadingFloorData: false,
                isLoadingProject: false,
                floorPlanData: null,
            }
        case GET_FLOOR_PLAN_DATA:
          return{
            ...state,
            status: GET_FLOOR_PLAN_DATA,
            floorPlan: action.params.floorPlan
          } 
        case SAVE_FLOOR_PLAN_DATA: 
          return {
            ...state,
            status: SAVE_FLOOR_PLAN_DATA
          }
        case SAVE_FLOOR_PLAN_DATA_SUCCESS:
          return {
            ...state,
            status: SAVE_FLOOR_PLAN_DATA_SUCCESS
          }
        case SAVE_FLOOR_PLAN_DATA_FAIL:
          return {
            ...state,
            status: SAVE_FLOOR_PLAN_DATA_FAIL,
            errMsg: action.params.errMsg
          }
        case DELETE_FLOOR_PLAN:
          return {
            ...state,
            status: DELETE_FLOOR_PLAN
          }
        case DELETE_FLOOR_PLAN_SUCCESS:
          return {
            ...state,
            status: DELETE_FLOOR_PLAN_SUCCESS
          }
        case DELETE_FLOOR_PLAN_FAIL:
          return {
            ...state,
            status: DELETE_FLOOR_PLAN_FAIL
          }

        case GET_VISUAL_GROUP_RSSI_INFO:
            return {
                ...state,
                status: action.type,
                mappingOrg: action.params.mappingOrg,
                mappingGroup: action.params.mappingGroup,
                mappingInteriorGraph: action.params.mappingInteriorGraph,
                virtualDeviceInfo: action.params.virtualDeviceInfo,
                wallInfo: action.params.wallInfo
            }

        case GET_VISUAL_GROUP_INTERIOR_GRAPH:
            return {
              ...state,
              status: GET_VISUAL_GROUP_INTERIOR_GRAPH,
              interiorGraphImgUrl: action.params.interiorGraphImgUrl,
              interiorGraphImgWidth: action.params.interiorGraphImgWidth,
              interiorGraphImgUrlDetail: action.params.interiorGraphImgUrlDetail
            }
            
        
        case DO_DISPLAY_BLUEPRINT:
          return {
              ...state,
              status: DO_DISPLAY_BLUEPRINT,
              displayBlueprint: action.params.displayBlueprint
          }
        
        case GET_VISUAL_MANAGER_DETAIL:
          return {
            ...state,
            status: GET_VISUAL_MANAGER_DETAIL,
            managerDetailData: action.params.managerDetailData
          }
        case GET_VISUAL_MANAGER_MODAL:
          return {
            ...state,
            status: GET_VISUAL_MANAGER_MODAL,
            isLoading: true
          }
        case GET_VISUAL_MANAGER_MODAL_SUCCESS:
          return {
            ...state,
            status: GET_VISUAL_MANAGER_MODAL_SUCCESS,
            managerDetail: action.params.managerDetail,
            managerDetailData: {
              ...state.managerDetailData,
              interiorImg: action.params.managerDetail?.interiorImg
            },
            isLoading: false
          }
        case GET_VISUAL_MANAGER_MODAL_FAIL:
          return {
            ...state,
            status: GET_VISUAL_MANAGER_MODAL_FAIL,
            isLoading: false
          }
        case SAVE_VISUAL_MANAGER_DETAIL:
          return {
            ...state,
            status: SAVE_VISUAL_MANAGER_DETAIL,
            saveInfo: action.params.info,
            saveConfirm: action.params.confirm
          }
        case DELETE_VISUAL_DATA:
          return{
            ...state,
            status: DELETE_VISUAL_DATA
          }
        case DELETE_VISUAL_DATA_SUCCESS:
          return{
            ...state,
            status: DELETE_VISUAL_DATA_SUCCESS  
          }
        case DELETE_VISUAL_DATA_FAIL:
          return {
            ...state,
            status: DELETE_VISUAL_DATA_FAIL
          }
        case GET_AVAILABLE_DEVICE_DATA:
          return {
            ...state,
            status: GET_AVAILABLE_DEVICE_DATA
          }
        case GET_AVAILABLE_DEVICE_DATA_SUCCESS:
          return {
            ...state,
            status: GET_AVAILABLE_DEVICE_DATA_SUCCESS,
            deviceList: action.params.deviceList
          }
        case GET_AVAILABLE_DEVICE_DATA_FAIL:
          return {
            ...state,
            status: GET_AVAILABLE_DEVICE_DATA_FAIL
          }
        case GET_VIRTUAL_DEVICE_DATA:
          return {
            ...state,
            status: GET_VIRTUAL_DEVICE_DATA
          }
        case GET_VIRTUAL_DEVICE_DATA_SUCCESS:
          return {
            ...state,
            status: GET_VIRTUAL_DEVICE_DATA_SUCCESS,
            deviceVirtual: action.params.deviceVirtual
          }
        case GET_VIRTUAL_DEVICE_DATA_FAIL:
          return {
            ...state,
            status: GET_VIRTUAL_DEVICE_DATA_FAIL
          }
        case GET_HEATMAP_DATA: 
          return {
            ...state,
            status: GET_HEATMAP_DATA,
            heatmapData: null,
            errMsg: null,
            popLoading: true
          }
        case GET_HEATMAP_DATA_SUCCESS:
          return {
            ...state,
            status: GET_HEATMAP_DATA_SUCCESS,
            heatmapData: action.params.heatmapData,
            channels: action.params.channels,
            popLoading: false
          }
        case GET_HEATMAP_DATA_FAIL:
          return {
            ...state,
            status: GET_HEATMAP_DATA_FAIL,
            // heatmapData: null,
            // errMsg: action.params.errMsg
            popLoading: false
          }
        case GET_HEATMAP_ALL_DATA:
          return {
            ...state,
            status: GET_HEATMAP_ALL_DATA,
            isLoading: true
          }
        case GET_HEATMAP_ALL_DATA_SUCCESS:
          return {
            ...state,
            status: GET_HEATMAP_ALL_DATA_SUCCESS,
            isLoading: false,
            heatmapAllData: action.params.heatmapAllData
          }
        case GET_HEATMAP_ALL_DATA_FAIL:
          return {
            ...state,
            status: GET_HEATMAP_ALL_DATA_FAIL,
            isLoading: false
          }
        case SAVE_VIRTUAL_DEVICE_INFO:
          return {
            ...state,
            status: SAVE_VIRTUAL_DEVICE_INFO
          }
        case SAVE_VIRTUAL_DEVICE_INFO_SUCCESS:
          return {
            ...state,
            status: SAVE_VIRTUAL_DEVICE_INFO_SUCCESS
          }
        case SAVE_VIRTUAL_DEVICE_INFO_FAIL:
          return {
            ...state,
            status: SAVE_VIRTUAL_DEVICE_INFO_FAIL
          }
        case DELETE_VIRTUAL_DEVICE:
          return {
            ...state,
            status: DELETE_VIRTUAL_DEVICE
          }
        case DELETE_VIRTUAL_DEVICE_SUCCESS:
          return {
            ...state,
            status: DELETE_VIRTUAL_DEVICE_SUCCESS
          }
        case DELETE_VIRTUAL_DEVICE_FAIL:
          return {
            ...state,
            status: DELETE_VIRTUAL_DEVICE_FAIL
          }
        case SAVE_GRAPH_DATA:
          return {
            ...state,
            status: SAVE_GRAPH_DATA
          }
        case SAVE_GRAPH_DATA_SUCCESS:
          return {
            ...state,
            status: SAVE_GRAPH_DATA_SUCCESS,
          }
        case SAVE_GRAPH_DATA_FAIL:
          return {
            ...state,
            status: SAVE_GRAPH_DATA_FAIL
          }
        case SAVE_SCALE_DATA_SUCCESS:
            return {
                ...state,
                status: SAVE_SCALE_DATA_SUCCESS,
            }
        case SAVE_SCALE_DATA_FAIL:
            return {
                ...state,
                status: SAVE_SCALE_DATA_FAIL
            }
        case SAVE_CHANNEL_RECOMMENDATION_SUCCESS:
        case SAVE_CHANNEL_RECOMMENDATION_FAIL:
        case SAVE_CHANNEL_RECOMMENDATION:
            return {
                ...state,
                status: action.type,
            }
        case GET_INTERIOR_GRAPH_SUCCESS:
            const visualList = state.visualList;
            for (const mapGroup of visualList.mappingGroups) {
                if (mapGroup.interiorGraph.id === action.data.id) {
                    mapGroup.interiorGraph = action.data;
                    break;
                }
            }
            return {
                ...state,
                status: action.type,
                mappingInteriorGraph: action.data,
            }
        case GET_INTERIOR_GRAPH:
        case GET_INTERIOR_GRAPH_FAIL:
            return {
                ...state,
                status: action.type,
            }
        case FILTER_FLOOR_PLAN:
          return {
            ...state,
            status: FILTER_FLOOR_PLAN,
            graphId: action.params.graphId,
            graphValue: action.params.graphValue
          }
        case PRE_CHANGE_FLOOR_PLAN:
            return {
                ...state,
                status: PRE_CHANGE_FLOOR_PLAN,
                nextFloorPlanId: action.params.nextFloorPlanId,
            }
        case CONTINUE_TO_CHANGE_FLOOR_PLAN:
        case END_CHANGING_FLOOR_PLAN:
            return {
                ...state,
                status: action.type,
            }
        case DO_SELECT_FLOOR_PLAN_PROJECT:
          return {
            ...state,
            status: DO_SELECT_FLOOR_PLAN_PROJECT,
            selectFloorPlanProject: action.params.selectFloorPlanProject,
            selectFloorPlanProjectEnvironment: action.params.selectFloorPlanProjectEnvironment,
            projectAddress: action.params.projectAddress,
          }
        case SET_FLOOR_PLAN_PROJECT_LIST:
          return {
            ...state,
            status: action.type,
            floorPlanProjectList: action.params.floorPlanProjectList
          }
        case DO_GET_FLOOR_PLAN_PROJECT_LIST:
          return {
            ...state,
            status: action.type,
            floorPlanProjectList: null
          }
        case DO_GET_FLOOR_PLAN_PROJECT_LIST_SUCCESS:
          return {
            ...state,
            status: action.type,
            floorPlanProjectList: action.params.floorPlanProjectList
          }
        case DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL: 
          return {
            ...state,
            status: action.type
          }
        case SAVE_SCALE_DATA:
            return {
                ...state,
                status: action.type
            }

          default:
            return state;
        }
       
  }

const visualReducers = (state = {
    errMsg: null,
    status: WAIT_INIT_VISUAL,
    isLoading: false,
    popLoading: false,
    mappingOrg: 0,
    mappingGroup: 0,
    mappingInteriorGraph: null,
    interiorGraphImgUrl: null,
    interiorGraphImgWidth: 0,
    virtualDeviceInfo: null,
    displayBlueprint: false,
    managerDetailData: null,
    interiorGraphImgUrlDetail: null,
    visualList: null,
    visualListId: null,
    heatmapData: null,
    heatmapAllData: [],
    deviceList: null,
    deviceVirtual: null,
    floorPlan: null,
    selectFloorPlanProject: null,
    selectFloorPlanProjectEnvironment: null,
    projectAddress: null,
    floorPlanProjectList: null
  }, action) => {
    switch (action.type) {
      default:
        return doAction(state, action);
    }
  }
  
  export default visualReducers;